export default __webpack_public_path__ + "static/chudakvsechno-f767ade67e440f4e208f05d0502f3059.png";